/** Rotating copy for hair styling loaders — no "AI" wording. */

export const HAIR_RECOMMEND_TITLE = 'Finding your match';

export const HAIR_RECOMMEND_DONE = 'Your picks are ready';

export const HAIR_RECOMMEND_MESSAGES = [
  'Reading your hair length and texture…',
  'Checking face shape and parting…',
  'Matching salon styles to your look…',
  'Balancing colour and contrast…',
  'Shortlisting your best options…',
];

export const HAIR_STYLE_APPLY_TITLE = 'Styling your hair';

export const HAIR_APPLY_DONE = 'Your look is ready';

export const HAIR_STYLE_PHASE_MESSAGES = {
  prepare: 'Reading your photo…',
  queue: 'Building your hairstyle prompt…',
  model: 'Generating your new cut…',
  render: 'Refining shape and strand detail…',
  blend: 'Matching lighting to your photo…',
  finish: 'Wrapping up your look…',
};

export function hairRecommendMessageForProgress(progress) {
  const p = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  if (p >= 100) return HAIR_RECOMMEND_DONE;
  if (p >= 82) return HAIR_RECOMMEND_MESSAGES[4];
  if (p >= 62) return HAIR_RECOMMEND_MESSAGES[3];
  if (p >= 42) return HAIR_RECOMMEND_MESSAGES[2];
  if (p >= 22) return HAIR_RECOMMEND_MESSAGES[1];
  return HAIR_RECOMMEND_MESSAGES[0];
}

export function hairStyleApplyMessageForProgress(progress) {
  const p = Math.max(0, Math.min(100, Math.round(Number(progress) || 0)));
  if (p >= 100) return HAIR_APPLY_DONE;
  if (p >= 90) return HAIR_STYLE_PHASE_MESSAGES.finish;
  if (p >= 72) return HAIR_STYLE_PHASE_MESSAGES.blend;
  if (p >= 54) return HAIR_STYLE_PHASE_MESSAGES.render;
  if (p >= 34) return HAIR_STYLE_PHASE_MESSAGES.model;
  if (p >= 20) return HAIR_STYLE_PHASE_MESSAGES.queue;
  return HAIR_STYLE_PHASE_MESSAGES.prepare;
}

export function setHairRecommendLoaderStep(setProgress, setMessage, progress) {
  const p = Math.max(0, Math.min(100, Math.round(progress)));
  setProgress(p);
  setMessage(hairRecommendMessageForProgress(p));
}

export function setHairStyleApplyLoaderStep(setProgress, setMessage, progress) {
  const p = Math.max(0, Math.min(100, Math.round(progress)));
  setProgress(p);
  setMessage(hairStyleApplyMessageForProgress(p));
}

